/** Listen before joining; leave after the inbound reducer finishes, not inside it. */
export function watchRoomAccess(
  load: () => Promise<unknown>,
  denied: (message: string) => void
): () => void {
  let stopped = false;
  let off: (() => void) | undefined;
  void load().then(module => {
    if (stopped) return;
    const mod = module as {
      onSyncRaw?: (fn: (raw: unknown) => void) => () => void;
      sharedSync?: () => { leaveRoom(): void };
    };
    off = mod.onSyncRaw?.(raw => {
      const frame = raw as { t?: string; code?: string } | null;
      if (frame?.t !== 'error' || frame.code !== 'room-private') return;
      queueMicrotask(() => {
        if (stopped) return;
        denied('This room is private. Ask its owner for an invitation.');
        mod.sharedSync?.().leaveRoom();
      });
    });
  }).catch(() => { /* REST and player errors remain available. */ });
  return () => { stopped = true; off?.(); };
}
